import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../../../axios";
import { connect, useDispatch, useSelector } from "react-redux";
import { clearCart, fetchCart, newAddToCart, removeCartItem, resetCart, storeUserRoute, verifyCheckoutSession, resetAddToCartStatus } from "../../../../_actions/cart.actions";
import { buildCourseDetailsURI, buildCourseDetailsURI1, getS3URL } from "../../../../_helpers/utilities";
import { Loading } from "../../../Other/Loading";
import { ApplyCoupon } from "../Coupon/ApplyCoupon";
// import StripePopup from "../StripePopup";
import RazorpayOverlay from "../Razorpay/RazorpayOverlay";
import "./cart.scss";
import Currency from "./Currency";
import { convertCurrency } from "./convertCurrency";
import { Trash2, BookOpen, ShieldCheck, Lock, Unlock, ArrowRight, Sparkles, Check, ChevronDown, ChevronUp } from "lucide-react";
import toast from "react-hot-toast";

const Cart = ({ user, loading }) => {
  const [overlay, setOverlay] = useState(false);
  // const [razorpayOverlay, setRazorpayOverlay] = useState(false);
  // const [stripeOverlay, setStripeOverlay] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  // const [viewLoading, setViewLoading] = useState(false);
  const [isTestMode, setIsTestMode] = useState(false);
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { CartItemsList, cartItems, comeFromRoute, currentState } = useSelector((state) => state.cart);
  
//"cartItems",cartItems);
  const { loggedIn, geoLocation } = useSelector((state) => state.authentication);

  const [CartListArray, setCartListArray] = useState([]);
 
  const [cartTotal, setCartTotal] = useState(0);
  const [viewLoading, setViewLoading] = useState(false);
  const [offersList, setOffersList] = useState([]);
  const [couponsList, setCouponsList] = useState([]);
  const [showCouponsDropdown, setShowCouponsDropdown] = useState(false);
  const [showSummaryDropdown, setShowSummaryDropdown] = useState(false);
  const couponsDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (couponsDropdownRef.current && !couponsDropdownRef.current.contains(event.target)) {
        setShowSummaryDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const res = await axiosInstance.get("/offers");
        if (res?.data && !res.data.error) {
          setOffersList(res.data.data);
        }
      } catch (err) {
        console.error("Error loading offers in Cart:", err);
      }
    };
    const fetchCoupons = async () => {
      try {
        const res = await axiosInstance.get("/coupons");
        if (res?.data && !res.data.error) {
          setCouponsList(res.data.data);
        }
      } catch (err) {
        console.error("Error loading coupons in Cart:", err);
      }
    };
    fetchOffers();
    fetchCoupons();
  }, []);

  console.log("DEBUG_CART:", { loading, currentState, loggedIn, cartItems, CartItemsList, isTestMode });

  const getCurrencySymbol = () => {
    return "₹";
  };

  const getItemOriginalPrice = (item) => {
    const hasBundle = loggedIn ? !!item?.BundleId : item.hasOwnProperty("bundleOneLiner");
    return hasBundle
      ? Number(item?.price || 0)
      : Number(item?.EnrollmentFee || item?.enrollmentFee || 0);
  };

  const groupCartItems = () => {
    const groups = [];
    const offerGroups = {};

    CartListArray.forEach((item) => {
      const couponVal = item?.PromoCodeApplied || item?.coupon;
      const isOffer = couponVal && typeof couponVal === "string" && couponVal.startsWith("OFFER_");

      if (isOffer) {
        const offerId = couponVal.split("_")[1];
        if (!offerGroups[offerId]) {
          offerGroups[offerId] = {
            type: "offer",
            offerId: offerId,
            items: [],
          };
          groups.push(offerGroups[offerId]);
        }
        offerGroups[offerId].items.push(item);
      } else {
        groups.push({
          type: "standalone",
          item: item,
        });
      }
    });

    return groups;
  };

  const fetchSubtotalOriginalPrice = () => {
    const items = loggedIn ? cartItems : CartItemsList;
    if (items && items.length > 0) {
      return items.reduce((acc, item) => acc + getItemOriginalPrice(item), 0);
    }
    return 0;
  };

  const getAppliedMultiCourseCoupon = () => {
    for (const item of CartListArray) {
      const code = item?.PromoCodeApplied || item?.coupon;
      if (code) {
        const found = couponsList.find(c => c.code === code.trim().toUpperCase());
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  const getCourseSpecificCoupons = (item) => {
    const courseId = Number(item?.ID || item?.CourseId || 0);
    if (!courseId) return [];

    const price = Number(item?.EnrollmentFee || item?.enrollmentFee || 0);

    return couponsList.filter(c => 
      Number(c.courseId) === courseId && 
      price >= Number(c.minAmount || 0)
    );
  };

  const getAvailableCoupons = () => {
    const cartCourses = CartListArray.filter(item => {
      const hasBundle = loggedIn ? !!item?.BundleId : item.hasOwnProperty("bundleOneLiner");
      return !hasBundle;
    });

    return couponsList.filter(c => {
      if (c.courseId) {
        // Course specific coupon
        const matchingCourse = cartCourses.find(item => Number(item?.ID || item?.CourseId || 0) === Number(c.courseId));
        if (!matchingCourse) return false;
        const price = Number(matchingCourse?.EnrollmentFee || matchingCourse?.enrollmentFee || 0);
        return price >= Number(c.minAmount || 0);
      } else {
        // Global/Multi-course coupon
        const minCourses = Number(c.minCourses || 1);
        const minAmount = Number(c.minAmount || 0);
        if (cartCourses.length < minCourses) return false;
        if (minAmount > 0) {
          return cartCourses.some(item => Number(item.EnrollmentFee || item.enrollmentFee || 0) >= minAmount);
        }
        return true;
      }
    });
  };

  const getCourseNameForCoupon = (coupon) => {
    if (!coupon.courseId) return null;
    const course = CartListArray.find(item => Number(item?.ID || item?.CourseId || 0) === Number(coupon.courseId));
    return course ? (course.CourseName || course.name) : "Selected Course";
  };

  const isCouponApplied = (coupon) => {
    return CartListArray.some(item => {
      const code = item?.PromoCodeApplied || item?.coupon;
      return code && code.trim().toUpperCase() === coupon.code.trim().toUpperCase();
    });
  };

  const handleApplySelectedCoupon = async (coupon) => {
    // Determine the courseId to use
    let courseId = null;
    if (coupon.courseId) {
      courseId = Number(coupon.courseId);
    } else {
      const firstCourse = CartListArray.find(item => {
        const hasBundle = loggedIn ? !!item?.BundleId : item.hasOwnProperty("bundleOneLiner");
        return !hasBundle;
      });
      if (firstCourse) {
        courseId = firstCourse.ID || firstCourse.CourseId;
      }
    }

    if (!courseId) {
      toast.error("Add at least one course to apply the coupon.");
      return;
    }

    setViewLoading(true);
    try {
      const res = await axiosInstance.post(`/promoCode?country=${user.country_code || "CA"}`, {
        coupon: coupon.code,
        courseId: courseId
      });
      if (res?.data && !res.data.error) {
        toast.success(`Coupon ${coupon.code} applied successfully!`);
        dispatch(fetchCart());
      } else {
        toast.error(res?.data?.message || "Failed to apply coupon.");
      }
    } catch (err) {
      console.error("Error applying coupon:", err);
      toast.error("Failed to apply coupon.");
    } finally {
      setViewLoading(false);
    }
  };

  const fetchTotalDiscount = () => {
    // Check if a multi-course coupon is applied
    const appliedCoupon = getAppliedMultiCourseCoupon();
    if (appliedCoupon) {
      if (appliedCoupon.courseId) {
        // Specific course coupon discount
        const targetCourse = CartListArray.find(item => {
          const hasBundle = loggedIn ? !!item?.BundleId : item.hasOwnProperty("bundleOneLiner");
          return !hasBundle && Number(item?.ID || item?.CourseId) === Number(appliedCoupon.courseId);
        });
        if (targetCourse) {
          const price = getItemOriginalPrice(targetCourse);
          return (price * Number(appliedCoupon.discountPercent)) / 100;
        }
        return 0;
      } else {
        // Global coupon discount
        const subtotal = fetchSubtotalOriginalPrice();
        return (subtotal * Number(appliedCoupon.discountPercent)) / 100;
      }
    }

    let totalDiscount = 0;
    const groups = groupCartItems();

    groups.forEach((group) => {
      if (group.type === "offer") {
        const offer = offersList.find((o) => String(o.id) === String(group.offerId));
        const originalSum = group.items.reduce((acc, item) => acc + getItemOriginalPrice(item), 0);
        if (offer) {
          const discount = originalSum - Number(offer.discountedAmount);
          if (discount > 0) {
            totalDiscount += discount;
          }
        }
      } else {
        const item = group.item;
        if (item?.PromoApplied && item?.DiscountPercent) {
          const price = getItemOriginalPrice(item);
          totalDiscount += (price * item.DiscountPercent) / 100;
        }
      }
    });

    return totalDiscount;
  };

  React.useEffect(() => {
    fetch("http://localhost:3200/debug-log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        loading,
        currentState,
        loggedIn,
        cartItemsCount: cartItems?.length,
        cartItemsListCount: CartItemsList?.length,
        cartItems,
        CartItemsList,
        isTestMode
      })
    }).catch(err => {});
  }, [loading, currentState, loggedIn, cartItems, CartItemsList, isTestMode]);

  React.useEffect(() => {
    const fetchSystemMode = async () => {
      try {
        const res = await axiosInstance.get("/system-mode");
        if (res?.data && !res.data.error) {
          setIsTestMode(res.data.mode === "test");
        }
      } catch (error) {
        console.error("Error fetching system mode in Cart:", error);
      }
    };
    fetchSystemMode();
  }, []);

  React.useEffect(() => {
    if (loggedIn) {
      setCartListArray(cartItems);
    } else {
      setCartListArray(CartItemsList);
    }
  }, [loggedIn, CartItemsList, cartItems]);

  React.useEffect(() => {
    dispatch(resetAddToCartStatus());
    if (loggedIn) {
      dispatch(fetchCart());
    }
  }, [loggedIn, dispatch]);

  React.useEffect(() => {
    if (comeFromRoute === "CART") {
      dispatch(storeUserRoute(null));
      dispatch(resetCart());
      dispatch(fetchCart());
    }
  }, [comeFromRoute, dispatch]);

  // open payment Modal
  React.useEffect(() => {
    if (comeFromRoute === "CART" && geoLocation) {
      setTimeout(() => {
        handleMakePayment()
      }, 500);
    }
  }, [comeFromRoute, CartItemsList, cartItems, geoLocation])

  React.useEffect(() => {
    if (geoLocation?.state?.comeFrom === "OpenPaymentOption" && geoLocation) {
      handleMakePayment()
    }
  }, [geoLocation?.state?.comeFrom, loading, cartItems, geoLocation])


  React.useEffect(() => {
    if (geoLocation?.state?.comeFrom === "OpenPaymentOption" && geoLocation) {
      if (loggedIn) dispatch(fetchCart());
      setTimeout(() => {
        setOpenModal(true)
      }, 1000);
    }
  }, [geoLocation?.state?.comeFrom, geoLocation])

  React.useEffect(() => {
    if (openModal) {
      setOpenModal(false)
      handleMakePayment()
    }
  }, [openModal])




  const popupCloseHandler = () => {
    setOverlay(false);
    // setOverlay(null);
  };


  const handleRemoveItem = (event, cartItem, items, countryCode) => {
    event.preventDefault();
    if (!loggedIn) {
      const couponVal = items?.PromoCodeApplied || items?.coupon;
      const isOffer = couponVal && typeof couponVal === "string" && couponVal.startsWith("OFFER_");

      let newArray = CartItemsList;
      let check = newArray.some(obj => obj.ID === items.ID);
      if (check) {
        let updateVal;
        if (isOffer) {
          updateVal = newArray.filter((obj) => (obj?.PromoCodeApplied || obj?.coupon) !== couponVal);
        } else {
          updateVal = newArray.filter((obj) => obj.ID !== items.ID);
        }

        let oldVal = 0;
        updateVal.forEach((obj) => {
          if ("bundleOneLiner" in obj) {
            oldVal += obj.price;
          } else {
            oldVal += obj.EnrollmentFee;
          }
        });
        setCartTotal(oldVal);

        return dispatch(
          newAddToCart(updateVal)
        );
      }
    } else {
      dispatch(removeCartItem(items.CourseId || items.BundleId, countryCode));
    }
  };

  const handleClearCart = (event) => {
    event.preventDefault();
    if (!loggedIn) {
      return dispatch(
        resetCart()
      );
    } else {
      dispatch(clearCart());
    }
  };

  // React.useEffect(() => {
  //   return () => {
  //     if (viewLoading) dispatch(storeUserRoute(null))
  //   }
  // }, [])


  const handleMakePayment = (event) => {

    // event.preventDefault();
    if (!loggedIn) {
      dispatch(storeUserRoute("CART"));
      navigate("/login");
    } else {
      let items = !loggedIn ? CartItemsList : cartItems;
      //console.log("svcs",items)
      // console.log("🚀 ~ file: Cart.js:111 ~ handleMakePayment ~ user:", user)
      // console.log("🚀 ~ file: Cart.js:95 ~ handleMakePayment ~ items:", items)
      if (items.length > 0) {
        // dispatch(storeUserRoute(null))
        localStorage.removeItem("ck_session");
        localStorage.setItem(
          "ck_session",
          JSON.stringify({
            session: items[0].sessionId,
            country_code: user.country_code,
          })
        );
        if (isTestMode || items[0]?.EnrollmentFee == 0) {
          const country = user?.country_code;
          dispatch(verifyCheckoutSession(items[0]?.sessionId, country, false));
        } else if (user.country_code === "IN" && items[0]?.EnrollmentFee > 0) {
          // razorpay
          setOverlay("razorpay");
        } else {
          // stripe
          setOverlay("razorpay");
          // setOverlay("stripe");
          return;
        }
      }
    };
  };

  const renderOverlay = (source) => {
    switch (source) {
      case "stripe":
        return (
          // <StripePopup
          //   onClose={popupCloseHandler}
          //   cartItems={cartItems}
          // ></StripePopup>
          <></>
        );
      case "razorpay":
        return <RazorpayOverlay onClose={popupCloseHandler} user={user} amount={fetchPrice()}/>;
      default:
        return null;
    }
  };

  const viewName = () => {
    return (
      <div className="cart-header">
        {!loggedIn ? CartListArray.length > 0 ? t("Shopping Cart") : "" : (user && user.userName + "'s" + t(" Shopping Cart"))}
      </div>
    );
  };

  const Redirect = (item) => {
   
    let url = null;
   
    if (loggedIn) {
      url = buildCourseDetailsURI1(
        item?.Subcategory ? item?.Subcategory : "",
        item?.CourseName ? item?.CourseName : item?.name,
        item?.ID ? item?.ID : item?.BundleId,
        item?.BundleId
      );
    } else if (!loggedIn && "bundleOneLiner" in item) {
      url = buildCourseDetailsURI(
        item?.SubCategory ? item?.Subcategory : "",
        item?.CourseName ? item?.CourseName : item?.name,
        item?.ID ? item?.ID : item?.BundleId,
        item?.BundleId
      );
      let newUrl = url.replace("/categories", "/bundle");
      return navigate(newUrl);
    } else {
      url = buildCourseDetailsURI(
        item?.SubCategory ? item?.Subcategory : "",
        item?.CourseName ? item?.CourseName : item?.name,
        item?.ID ? item?.ID : item?.BundleId,
        item?.BundleId
      );
    }
    //console.log("url", url);
    navigate(url);
  };

  React.useEffect(() => {
    if (CartItemsList.length > 0) {
      let bundleSum = CartItemsList.filter(x => "bundleOneLiner" in x).map((data) => parseInt(data.price));
      let courseSum = CartItemsList.filter(x => "bundleOneLiner" in !x).map((data) => parseInt(data.EnrollmentFee
      ));
      let mergeArray = bundleSum.concat(courseSum);
      let sum = mergeArray.reduce(
        (previousScore, currentScore, index) => previousScore + currentScore,
        0);
      setCartTotal(sum);
    }

  }, [CartItemsList]);

  const fetchPrice = () => {
    const originalPrice = fetchSubtotalOriginalPrice();
    const discount = fetchTotalDiscount();
    const totalCAD = Math.max(0, originalPrice - discount);
    
    if (user?.country_code === "IN") {
      const exchangeRate = 62.88;
      return (totalCAD * exchangeRate).toFixed(2);
    }
    return totalCAD.toFixed(2);
  };

  const handleApplyCartCoupon = async (code) => {
    const firstCourse = CartListArray.find(item => {
      const hasBundle = loggedIn ? !!item?.BundleId : item.hasOwnProperty("bundleOneLiner");
      return !hasBundle;
    });
    if (!firstCourse) {
      toast.error("Add at least one course to apply the coupon.");
      return;
    }
    const courseId = firstCourse.ID || firstCourse.CourseId;
    setViewLoading(true);
    try {
      const res = await axiosInstance.post(`/promoCode?country=${user.country_code || "CA"}`, {
        coupon: code,
        courseId: courseId
      });
      if (res?.data && !res.data.error) {
        toast.success(`Coupon ${code} applied successfully!`);
        dispatch(fetchCart());
      } else {
        toast.error(res?.data?.message || "Failed to apply coupon.");
      }
    } catch (err) {
      console.error("Error applying coupon:", err);
      toast.error("Failed to apply coupon.");
    } finally {
      setViewLoading(false);
    }
  };

  const renderCouponBanner = () => {
    const cartCourses = CartListArray.filter(item => {
      const hasBundle = loggedIn ? !!item?.BundleId : item.hasOwnProperty("bundleOneLiner");
      return !hasBundle;
    });

    const qualifyingCoupons = couponsList.filter(c => {
      const minCourses = Number(c.minCourses || 1);
      const minAmount = Number(c.minAmount || 0);
      const courseId = c.courseId;

      if (courseId) {
        return false;
      } else {
        // Global coupon
        if (cartCourses.length < minCourses) return false;
        if (minAmount > 0) {
          return cartCourses.some(item => Number(item.EnrollmentFee || item.enrollmentFee || 0) >= minAmount);
        }
        return true;
      }
    });

    if (qualifyingCoupons.length === 0) return null;

    const appliedCoupon = getAppliedMultiCourseCoupon();

    // return (
      // <div className="cart-coupon-selection-container">
      //   <div 
      //     className="coupon-selection-header" 
      //     onClick={() => setShowCouponsDropdown(!showCouponsDropdown)}
      //     style={{ cursor: "pointer" }}
      //   >
      //     <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
      //       <Sparkles className="banner-icon" size={20} />
      //       <h3>Available Coupons & Offers ({qualifyingCoupons.length})</h3>
      //     </div>
      //     {showCouponsDropdown ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      //   </div>
        
      //   {showCouponsDropdown && (
      //     <div className="coupon-selection-list scrollable">
      //       {qualifyingCoupons.map((coupon) => {
      //         const isAlreadyApplied = appliedCoupon?.code === coupon.code;
      //         return (
      //           <div
      //             key={coupon.id}
      //             className={`cart-coupon-alert-banner ${isAlreadyApplied ? "applied" : "eligible"}`}
      //             style={{ marginBottom: "10px" }}
      //           >
      //             <div className="banner-content">
      //               <p className="banner-text">
      //                 <strong>{coupon.code}</strong> — Get <strong>{Number(coupon.discountPercent)}% OFF</strong>{" "}
      //                 {coupon.courseId ? (
      //                   <>
      //                     on{" "}
      //                     <em>
      //                       {cartCourses.find(c => Number(c.ID || c.CourseId) === Number(coupon.courseId))?.CourseName || "selected course"}
      //                     </em>
      //                   </>
      //                 ) : (
      //                   "on your cart subtotal"
      //                 )}
      //                 {Number(coupon.minAmount) > 0 && ` (Min Course Price: ₹${Number(coupon.minAmount)})`}
      //               </p>
      //             </div>
      //             {isAlreadyApplied ? (
      //               <button
      //                 type="button"
      //                 className="btn-apply-coupon-banner done"
      //                 disabled={true}
      //               >
      //                 <Check size={16} /> <span>Applied</span>
      //               </button>
      //             ) : (
      //               <button
      //                 type="button"
      //                 className="btn-apply-coupon-banner"
      //                 onClick={(e) => {
      //                   e.stopPropagation();
      //                   handleApplyCartCoupon(coupon.code);
      //                 }}
      //                 disabled={viewLoading}
      //               >
      //                 {viewLoading ? "Applying..." : "Apply"}
      //               </button>
      //             )}
      //           </div>
      //         );
      //       })}
      //     </div>
      //   )}
      // </div>
    // );
  };

  return (
    <div className="cart-page-wrapper">
      <div className="cart-container">
        {loading || currentState === "processing" ? (
          <Loading />
        ) : CartListArray.length > 0 || cartItems.length > 0 ? (
          <div className="cart-content-grid">
            {/* Left side: Cart Items List */}
            <div className="cart-items-column">
              <div className="cart-column-header">
                {viewName()}
                <span className="items-count-badge">
                  {CartListArray.length} {CartListArray.length === 1 ? t("Item") : t("Items")}
                </span>
              </div>
              {/* {renderCouponBanner()} */}
                      <div className="items-list">
                {groupCartItems().map((group, groupIndex) => {
                  if (group.type === "offer") {
                    const offerId = group.offerId;
                    const offer = offersList.find((o) => String(o.id) === String(offerId));
                    const offerTitle = offer?.title || "Special Offer Pack";
                    const offerDiscounted = offer ? Number(offer.discountedAmount) : 0;
                    const offerOriginal = group.items.reduce((acc, item) => acc + getItemOriginalPrice(item), 0);
                    
                    return (
                      <div className="offer-pack-container" key={`offer-${offerId}`}>
                        <div className="offer-pack-header">
                          <div className="offer-pack-title-row">
                            <Sparkles className="offer-pack-icon" size={18} />
                            <h3 className="offer-pack-title">{offerTitle}</h3>
                            <span className="offer-pack-badge">All-in-One Pack</span>
                          </div>
                          <button
                            type="button"
                            className="btn-remove-pack"
                            onClick={(event) =>
                              handleRemoveItem(
                                event,
                                cartItems,
                                group.items[0],
                                user.country_code
                              )
                            }
                          >
                            <Trash2 size={15} />
                            <span>Remove Pack</span>
                          </button>
                        </div>
                        
                        <div className="offer-pack-courses">
                          {group.items.map((item, idx) => {
                            const itemImage = item?.imageFiles && item?.imageFiles.length > 0 
                              ? getS3URL(item?.imageFiles[0]?.fileName) 
                              : null;
                            const itemOriginalPrice = getItemOriginalPrice(item);
                            
                            return (
                              <div className="offer-pack-course-row" key={idx}>
                                <div className="course-thumbnail-mini" onClick={() => Redirect(item)}>
                                  {itemImage ? (
                                    <img src={itemImage} alt={item?.CourseName || item?.name} />
                                  ) : (
                                    <div className="item-thumbnail-placeholder">
                                      <BookOpen size={16} />
                                    </div>
                                  )}
                                </div>
                                <div className="course-info-mini">
                                  <h4 className="course-title-mini" onClick={() => Redirect(item)}>
                                    {item?.CourseName || item?.name}
                                  </h4>
                                  <span className="course-instructor-mini">
                                    {loggedIn 
                                      ? `${item?.firstName || ""} ${item?.lastName || ""}` 
                                      : (item?.instructorInfo 
                                          ? `${item?.instructorInfo?.firstName || ""} ${item?.instructorInfo?.lastName || ""}`
                                          : item?.instructorName || "")
                                    }
                                  </span>
                                </div>
                                <div className="course-price-mini">
                                  <span className="original-price line-through">
                                    {getCurrencySymbol()}{itemOriginalPrice.toFixed(2)}
                                  </span>
                                  <span className="included-tag">Included</span>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                        
                        <div className="offer-pack-footer">
                          <div className="offer-pack-pricing">
                            <span className="pricing-label">Pack Price:</span>
                            <span className="offer-original-total line-through mr-2">
                              {getCurrencySymbol()}{offerOriginal.toFixed(2)}
                            </span>
                            <span className="offer-discounted-total">
                              {getCurrencySymbol()}{offerDiscounted.toFixed(2)}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  } else {
                    const item = group.item;
                    const hasBundle = loggedIn ? !!item?.BundleId : item.hasOwnProperty("bundleOneLiner");
                    
                    // Get item image
                    const itemImage = hasBundle
                      ? (item?.imageLink ? getS3URL(item?.imageLink) : null)
                      : (item?.imageFiles && item?.imageFiles.length > 0 ? getS3URL(item?.imageFiles[0]?.fileName) : null);
                      
                    // Calculate display price
                    const itemDisplayPrice = getItemOriginalPrice(item);

                    const discountVal = item?.PromoApplied && item?.DiscountPercent 
                      ? (itemDisplayPrice * (100 - item.DiscountPercent)) / 100 
                      : null;

                    return (
                      <div className="cart-item-card" key={groupIndex}>
                        <div className="item-thumbnail-wrapper" onClick={() => Redirect(item)}>
                          {itemImage ? (
                            <img 
                              src={itemImage} 
                              alt={item?.CourseName ? item?.CourseName : item?.name} 
                              className="item-thumbnail" 
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.style.display = "none";
                              }}
                            />
                          ) : (
                            <div className="item-thumbnail-placeholder">
                              <BookOpen size={24} className="placeholder-icon" />
                            </div>
                          )}
                          {hasBundle && <span className="bundle-tag">Bundle</span>}
                        </div>

                        <div className="item-details">
                          <div className="item-info-header">
                            <h3 
                              onClick={() => Redirect(item)} 
                              className="item-title"
                            >
                              {item?.CourseName ? item?.CourseName : item?.name}
                            </h3>
                          </div>

                          <div className="item-meta">
                            {!hasBundle && (
                              <div className="instructor-text">
                                <span className="label">{t("Instructor")}:</span>{" "}
                                <span className="value">
                                  {loggedIn 
                                    ? `${item?.firstName || ""} ${item?.lastName || ""}` 
                                    : (item?.instructorInfo 
                                        ? `${item?.instructorInfo?.firstName || ""} ${item?.instructorInfo?.lastName || ""}`
                                        : item?.instructorName || "")
                                  }
                                </span>
                              </div>
                            )}

                            {/* Coupon Section */}
                            {loggedIn ? (
                              item?.PromotionalOffer === 1 && (
                                <div className="coupon-action-wrapper">
                                  <ApplyCoupon
                                    cartItem={item}
                                    countryCode={user.country_code}
                                  />
                                </div>
                              )
                            ) : (
                              item?.PromoTionalOffer === 1 && (
                                <div className="coupon-action-wrapper">
                                  <ApplyCoupon
                                    cartItem={item}
                                    countryCode={user.country_code}
                                  />
                                </div>
                              )
                            )}
                            {/* Course Specific Coupons */}
                            {!hasBundle && (() => {
                              const specificCoupons = getCourseSpecificCoupons(item);
                              if (specificCoupons.length === 0) return null;
                              const appliedCoupon = getAppliedMultiCourseCoupon();

                              return (
                                <div className="course-specific-coupons-list" style={{ marginTop: "8px", display: "flex", flexWrap: "wrap", gap: "6px" }}>
                                  {specificCoupons.map(coupon => {
                                    const isAlreadyApplied = appliedCoupon?.code === coupon.code;
                                    return (
                                      <div 
                                        key={coupon.id} 
                                        className={`course-coupon-pill-button ${isAlreadyApplied ? "applied" : "eligible"}`}
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "6px",
                                          padding: "4px 8px",
                                          borderRadius: "6px",
                                          fontSize: "0.75rem",
                                          fontWeight: "600",
                                          border: isAlreadyApplied ? "1px solid #10b981" : "1px dashed #f59e0b",
                                          background: isAlreadyApplied ? "rgba(16, 185, 129, 0.08)" : "rgba(245, 158, 11, 0.08)",
                                          color: isAlreadyApplied ? "#047857" : "#d97706"
                                        }}
                                      >
                                        <Sparkles size={12} style={{ color: isAlreadyApplied ? "#10b981" : "#f59e0b" }} />
                                        <span>{coupon.code} ({Number(coupon.discountPercent)}% OFF)</span>
                                        {isAlreadyApplied ? (
                                          <span style={{ color: "#10b981", display: "flex", alignItems: "center" }}>
                                            <Check size={12} />
                                          </span>
                                        ) : (
                                          <button
                                            type="button"
                                            onClick={() => handleApplyCartCoupon(coupon.code)}
                                            disabled={viewLoading}
                                            style={{
                                              background: "#2563eb",
                                              color: "#ffffff",
                                              border: "none",
                                              borderRadius: "4px",
                                              padding: "2px 6px",
                                              fontSize: "0.65rem",
                                              cursor: "pointer",
                                              fontWeight: "700",
                                              marginLeft: "4px"
                                            }}
                                          >
                                            Apply
                                          </button>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              );
                            })()}
                          </div>

                          <div className="item-card-actions">
                            <button
                              type="button"
                              className="btn-remove-item"
                              onClick={(event) =>
                                handleRemoveItem(
                                  event,
                                  cartItems,
                                  item,
                                  user.country_code
                                )
                              }
                            >
                              <Trash2 size={15} />
                              <span>{t("Remove")}</span>
                            </button>
                          </div>
                        </div>

                        <div className="item-pricing">
                          {discountVal ? (
                            <>
                              <span className="original-price">{getCurrencySymbol()}{itemDisplayPrice}</span>
                              <span className="final-price">{getCurrencySymbol()}{discountVal}</span>
                            </>
                          ) : (
                            <span className="final-price">
                              {itemDisplayPrice > 0 ? `${getCurrencySymbol()}${itemDisplayPrice}` : t("Free")}
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
              
              <div className="cart-actions-left-row">
                <button
                  type="button"
                  className="btn-clear-cart"
                  onClick={(event) => handleClearCart(event)}
                >
                  <Trash2 size={16} />
                  <span>{t("Empty your cart")}</span>
                </button>
              </div>
            </div>

            {/* Right side: Order Summary Card */}
            <div className="cart-summary-column">
              <div className="summary-sticky-card">
                <h2 className="summary-title">{t("Order Summary")}</h2>
                
                <div className="summary-row">
                  <span className="summary-label">{t("Original Price")}</span>
                  <span className="summary-value">
                    {getCurrencySymbol()}{fetchSubtotalOriginalPrice()}
                  </span>
                </div>

                {fetchTotalDiscount() > 0 && (
                  <div className="summary-row discount-row">
                    <span className="summary-label">{t("Discounts")}</span>
                    <span className="summary-value">
                      -{getCurrencySymbol()}{fetchTotalDiscount().toFixed(2)}
                    </span>
                  </div>
                )}

                <div className="summary-row tax-row">
                  <span className="summary-label">{t("Taxes")}</span>
                  <span className="summary-value uppercase text-[10px] text-slate-400">
                    {t("Calculated at checkout")}
                  </span>
                </div>

                {/* Available Coupons Section */}
                <div className="summary-divider"></div>
                <div className="summary-coupons-container" ref={couponsDropdownRef}>
                  <button 
                    type="button" 
                    className="btn-coupons-toggle"
                    onClick={() => setShowSummaryDropdown(!showSummaryDropdown)}
                  >
                    <div className="toggle-left">
                      <Sparkles size={16} className="sparkle-icon" />
                      <span>
                        {getAppliedMultiCourseCoupon() ? `${t("Applied")}: ${getAppliedMultiCourseCoupon().code}` : t("Available Coupons")}
                      </span>
                      {!getAppliedMultiCourseCoupon() && (
                        <span className="coupons-count-badge">{getAvailableCoupons().length}</span>
                      )}
                    </div>
                    {showSummaryDropdown ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                  </button>

                  {showSummaryDropdown && (
                    <div className="summary-coupons-dropdown">
                      {getAvailableCoupons().length === 0 ? (
                        <div className="no-coupons-message">
                          {t("No coupons available")}
                        </div>
                      ) : (
                        <div className="coupons-list-wrapper">
                          {getAvailableCoupons().map((coupon) => {
                            const isApplied = isCouponApplied(coupon);
                            const courseName = getCourseNameForCoupon(coupon);
                            return (
                              <div 
                                key={coupon.id} 
                                className={`summary-coupon-item ${isApplied ? "applied" : ""}`}
                                onClick={() => {
                                  if (!isApplied) {
                                    handleApplySelectedCoupon(coupon);
                                    setShowSummaryDropdown(false);
                                  }
                                }}
                              >
                                <div className="coupon-item-info">
                                  <div className="coupon-item-code-row">
                                    <span className="coupon-item-code">{coupon.code}</span>
                                    <span className="coupon-item-discount">{Number(coupon.discountPercent)}% OFF</span>
                                  </div>
                                  {courseName ? (
                                    <div className="coupon-item-course-restriction">
                                      {t("Applicable only on:")} <strong>{courseName}</strong>
                                    </div>
                                  ) : (
                                    <div className="coupon-item-course-restriction global">
                                      {t("Applicable on entire cart")}
                                    </div>
                                  )}
                                </div>
                                <div className="coupon-item-action">
                                  {isApplied ? (
                                    <span className="coupon-applied-badge">
                                      <Check size={12} />
                                      {t("Applied")}
                                    </span>
                                  ) : (
                                    <span className="coupon-apply-action">
                                      {t("Apply")}
                                    </span>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="summary-divider"></div>

                <div className="summary-row total-row">
                  <span className="summary-label">{t("Total")}</span>
                  <span className="summary-value total-price">
                    {getCurrencySymbol()}{fetchPrice()}
                  </span>
                </div>

                {/* Checkout Action Button */}
                <button
                  type="button"
                  className={`btn-checkout-primary ${isTestMode ? "test-mode" : ""}`}
                  onClick={(event) => handleMakePayment(event)}
                >
                  {isTestMode ? (
                    <>
                      <span>{t("Instant Checkout")}</span>
                      <span className="checkout-badge">BYPASS ACTIVE - FREE ENROLLMENT</span>
                    </>
                  ) : (
                    <>
                      <span>{t("Proceed to checkout")}</span>
                      <span className="checkout-badge">
                        {t("Redirecting to")} {user.country_code === "IN" ? "Razorpay" : "Stripe"}
                      </span>
                    </>
                  )}
                  {isTestMode ? <Unlock className="checkout-btn-icon" size={18} /> : <Lock className="checkout-btn-icon" size={18} />}
                </button>

                <div className="security-guarantee">
                  <ShieldCheck size={14} className="guarantee-icon" />
                  <span>30-Day Money-Back Guarantee</span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="empty-cart-container">
            <div className="empty-cart-illustration">
              <svg width="240" height="240" viewBox="0 0 24 24" fill="none" className="empty-cart-svg">
                <circle cx="12" cy="12" r="11" fill="#f0f4f8" />
                <path d="M6 8h13.2l-1.8 7.2H8.4L6 8z" stroke="#264b82" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="9.6" cy="18.6" r="1.2" fill="#264b82" />
                <circle cx="16.8" cy="18.6" r="1.2" fill="#264b82" />
                <path d="M4 5h2l2.4 8h9.6l1.8-7H7.5" stroke="#264b82" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            
            <h2 className="empty-cart-title">
              {t("Hey")}, <span className="username">{loggedIn ? user && user.userName : t("Student")}</span>
            </h2>
            <p className="empty-cart-subtitle">{t("Your shopping cart is currently empty.")}</p>
            
            <Link to="/courses" className="btn-explore-courses">
              {t("Find Something Interesting")}
              <ArrowRight size={18} />
            </Link>
          </div>
        )}
      </div>
      {overlay && renderOverlay(overlay)}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.users;
  const { geoLocation } = state.authentication;
  const { loading } = state.cart;
  return {
    user: { ...user, ...geoLocation },
    loading,
  };
};

export default connect(mapStateToProps)(Cart);
